// /src/data/playbooks.js
//
// `web` is optional: a static page under public/ with a browsable version.
//
// The two Verify-First entries are generated content. Their files come from
// scripts/build-verify-first.py, and their descriptions are sentences that
// script renders from counts it measures in the source Markdown; its --check
// fails if the text below and the measurement disagree. Change the source, not
// these strings. `time` is prose words at 230 words per minute (18,805 and
// 16,851 words, measured 2026-09-26; the runbook adds 4,094 words of templates).
export const playbooks = [
  {
    title: 'Verify-First Agent Playbook',
    slug: 'verify-first-agent-playbook',
    description:
      'The why and the what of working with AI coding agents: 17 patterns (P1 to P17), most of them born from a real incident, with what each caught and what it costs, plus a decision guide, an honest section on costs and a glossary.',
    time: '~80 min',
    audience: 'AI agent users, all levels',
    formats: ['PDF', 'Markdown'],
    web: '/playbooks/verify-first/playbook.html'
  },
  {
    title: 'Verify-First Agent Runbook',
    slug: 'verify-first-agent-runbook',
    description:
      'The how: 16 step-by-step procedures (R0 to R15), 12 incident procedures and 12 copy-ready templates (T1 to T12), including a deferral gate script and a claims checker sketch.',
    time: '~75 min',
    audience: 'AI agent users, all levels',
    formats: ['PDF', 'Markdown'],
    web: '/playbooks/verify-first/runbook.html'
  },
  {
    title: 'HIPAA Compliance Security Audit Checklist',
    slug: 'hipaa-compliance-security-audit-checklist',
    description:
      'Step-by-step security audit framework for healthcare organizations. Covers technical safeguards, risk assessments, and documentation requirements.',
    time: '45 min',
    audience: 'Healthcare IT',
    formats: ['PDF', 'Markdown']
  },
  {
    title: 'Incident Response for Healthcare Breaches',
    slug: 'incident-response-healthcare-breaches',
    description:
      'Copy-paste runbook for healthcare data breach response. Includes notification timelines, forensic steps, and regulatory reporting.',
    time: '30 min',
    audience: 'SecOps',
    formats: ['PDF', 'Markdown']
  },
  {
    title: 'EHR Integration Security Best Practices',
    slug: 'ehr-integration-security-best-practices',
    description:
      'Security checklist for Epic, Cerner, and HL7 FHIR integrations. Access controls, encryption, and audit logging.',
    time: '60 min',
    audience: 'Healthcare IT',
    formats: ['PDF', 'Markdown']
  },
  {
    title: 'Blockchain Security Assessment Framework',
    slug: 'blockchain-security-assessment-framework',
    description:
      'Security testing methodology for permissioned blockchain deployments. Smart contract auditing and node hardening.',
    time: '90 min',
    audience: 'Blockchain Developers',
    formats: ['PDF', 'Markdown']
  }
];